import {
  Component,
  HostListener,
  Inject,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ItineraryComponent } from '@sc/ui-components';
import { ScreenUtils } from '@sc/utils';
import { ItineraryInputData } from '@sc/data-access-models';

@Component({
  selector: 'sc-itinerary-dialog',
  template: `
    <sc-itinerary
      [fitter]="data.fitter"
      [userLocation]="data.userAddress"
      [alt]="false"
      (closeEvent)="onCloseSheet()"
    ></sc-itinerary>
  `,
  styleUrls: ['./itinerary-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [ItineraryComponent],
})
export class ItineraryDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ItineraryInputData,
    private readonly dialogRef: MatDialogRef<ItineraryDialogComponent>
  ) {}

  onCloseSheet() {
    this.dialogRef.close();
  }

  @HostListener('window:resize', ['$event'])
  closeOnResize() {
    if (!ScreenUtils.isDesktopResolution()) {
      this.onCloseSheet();
    }
  }
}
